import React, {useState} from 'react';
import {Card, Row, Col, Button} from 'antd';
import { ResponseResult } from '../../types';
import { request } from '../../services/Request';
import {useDropzone} from 'react-dropzone';
import Swal from 'sweetalert2';

function ConceptPaymentsUpload(){

    const [selectedFiles, setFiles]:any = useState([]);

    const onDrop = (acceptedFiles:any) => {
        let files = selectedFiles;
        files = acceptedFiles;
        setFiles(files);
    };
    
    const {getRootProps, getInputProps } = useDropzone({
        multiple:true, 
        onDrop: onDrop,
        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
    });

    const upload = () => {
        if(selectedFiles.length > 0){
            Swal.fire('Subir pagos','Cargando...');
            Swal.showLoading();
            const data = new FormData();
            for(let file of selectedFiles){
                data.append('files', file);
            }
            request('/api/payment/upload/paid',{
                method: 'POST',
                file:true,
                body: data
            })
            .then((result:ResponseResult)=>{
                Swal.close();                
                if(result.data){
                    Swal.fire('Subir pagos', 'El proceso ha terminado.', 'success');
                }else{
                    Swal.fire('Subir pagos', 'Ocurrió un error', 'error');
                }
            })
        }
    }

    return (
        <div id="upload-payments">
            <Row>
                <Col xs={24} md={{span:18,offset:3}}>
                    <Card>
                        <h3>Subir pagos realizados a conceptos de alumnos</h3>    
                        <a href="/plantilla_conceptos_pagados.xlsx" className="mb-3">Descargar plantilla</a>                    
                            <div className='file-drop justify-center mt-5' {...getRootProps()}>
                                <input {...getInputProps({multiple:true})} />
                                <p className="text-center mb-4">Arrastra y suelta tus archivos o presiona aquí para elegirlos.</p> 
                            </div>
                            <p><b>Archivo seleccionado:</b></p>
                            <ul className="mb-5">
                                {
                                    selectedFiles.map((file:any,key:number)=>(
                                        <li key={key}>
                                            { file.name }
                                        </li>
                                    ))
                                }
                            </ul>
                            <Button type="primary" onClick={upload}>Subir archivo</Button>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default ConceptPaymentsUpload;